import script from "./PackageDataDetailCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PackageDataDetailCard.vue?vue&type=script&lang=ts&setup=true"

import "./PackageDataDetailCard.vue?vue&type=style&index=0&id=41fcaf16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41fcaf16"]])

export default __exports__